import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import facebook from "../../../assets/DigitalMarketing/image/integration/logos_facebook.svg";
import facebookbtn from "../../../assets/DigitalMarketing/image/integration/icon_facebook_btn.svg";
import vector from "../../../assets/DigitalMarketing/image/integration/Vector.svg";
import logo from "../../../assets/DigitalMarketing/image/integration/Group 1000002636.svg";
import { FacebookLabel } from "./utils";
import { useAddfacebooksettingMutation, useGetFacebooksettingQuery } from "../../../Service/Integration";
import { updatefacebooksetting } from "../../../store/reducers/digitalmarketing/customer";

function FacebookDetail(props) {
  const { open, message, openSnackBar, type } = useSnackbar();
  const { id, errorMessage, callBackforErrorMessage } = props;
  const dispatch = useDispatch<any>();
  
  const [error, setError] = useState();
 
  const [submit, setSubmit] = useState(false);

  const [addfacebooksetting,{ isLoading:addLoading }] = useAddfacebooksettingMutation();
  const facebookSettin = useSelector(
    (state: any) => state.customer.facebooksetting
  );
  // console.log(facebookSettin);
  
  const { data: facebookSetting } = useGetFacebooksettingQuery(id || "1", {
    refetchOnMountOrArgChange: true,
  });
  // console.log(facebookSetting);

  const handleChangeData = (e, validation) => {
    setError(validation);
    // console.log("facebooksetting", facebookSetting);
    setSubmit(false);
    dispatch(
      updatefacebooksetting({
        [e.target.name]: e.target.value,
      })
    );
  };
  
  const savefacebooksetting = async () => {
    setSubmit(true);
    if (
      facebookSettin.userAccountId.trim().length !== 0 &&
      facebookSettin.accessToken.trim().length !== 0)
     {
      try {
        const res: any = await addfacebooksetting(facebookSettin).unwrap();
        openSnackBar(res.message, "success");
      } catch (err: any) {
        // console.log(err.response.data.error);
      }
    }
    else {
      if (facebookSettin.userAccountId.trim().length !== 0){
      openSnackBar("User account id required", "error");
      }
      // else if (facebookSettin.campaignId.trim().length !== 0){
      //   openSnackBar("User Campaign Id Required", "error");
      // }
        else {
          openSnackBar("User accesstoken required", "error");
        }

    }
  };
  useEffect(() => {
    dispatch(
      updatefacebooksetting({
        ...facebookSetting,
      })
    );
  }, [facebookSetting]);
  return (
    <React.Fragment>
      <Toast open={open} type={type} message={message} />
      <Container fluid>
        {/* <Row className="integration-facebooklayout">
          <Col md={7} className="integration-facebook  mt-4">
            <div className="d-flex justify-content-center px-5">
              <img className="icon-img3 mt-1 " src={logo} alt="logo" />
              <img className="login-logo mt-3 mx-3" src={vector} alt="vector" />
              <img className="icon-img3 mt-1" src={facebook} alt="google" />
            </div>
            <h1 className="facebook-message">
              Receive new leads from Facebook & Integration Lead Ads in your
              Mimo konnect account
            </h1>
            <div className="center">
              <Button className="facebook btn" id="btn-facebook">
                <span>
                  <img
                    className="icon-btnfb mt-1"
                    src={facebookbtn}
                    alt="facebook"
                  />
                </span>{" "}
                Login With Facebook
              </Button>
            </div>
          </Col>
        </Row> */}
        {/* <div className="integration-facebooklayout">
              <div className="integration-facebook">
                <div className="center">
                  <img className="icon-img1 mt-1" src={logo} alt="logo"/>
                  <span><img className="login-logo mt-1" src={vector} alt="vector"/></span>
                  <span><img className="icon-img3 mt-1" src={facebook} alt="facebook"/></span>  
                </div>
                <h1 className="facebook-message">Receive new leads from Facebook & Integration Lead Ads in your Mind and Mom account</h1>
                <div className="center">
                    <Button
                      className="facebook btn"
                      id="btn-facebook"
                    >
                     <span><img className="icon-btnfb mt-1" src={facebookbtn} alt="facebook"/></span> Login With Facebook
                    </Button>
                </div>
            </div> 
          </div>*/}
           <Row className="integration-whatsapplayout">
          <Col md={12}>
            {/* <Tabs tablist={values} active={active} setActive={setActive} /> */}
          </Col>
          <Col md={12} className="integration-whatsapp">
            <div className="mx-4">
                <>
                  {FacebookLabel.map((item) => (
                    <div className="mt-3 w-50">
                      <item.tag
                        label={item.label}
                        name={item.key_name}
                        validation={item.validation}
                        handleChange={handleChangeData}
                        {...item}
                        submit={submit}
                        {...facebookSettin}
                      />
                    </div>
                  ))}
                  <Button
                    onClick={() => {
                      savefacebooksetting();
                    }}
                    variant="contained"
                    id="btn-chat"
                    className="whatsapp-btn mx-1" disabled={addLoading}
                  >
                    {addLoading?"Wait": !facebookSetting?.userAccountId ? "Save" : "Update"}
                  </Button>
                </>
            
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}
export default React.memo(FacebookDetail);
